export const snakeToTitleCase = (str: string): string =>
  str
    .split('_')
    .filter(x => x.length > 0)
    .map(x => x.charAt(0).toUpperCase() + x.slice(1).toLocaleLowerCase())
    .join(' ')

export const snakeToSentenceCase = (str: string): string => {
  const sentence = str
    .split('_')
    .filter(x => x.length > 0)
    .join(' ')
  return (
    sentence.charAt(0).toUpperCase() + sentence.slice(1).toLocaleLowerCase()
  )
}

export const toTitleCase = (str?: string): string => {
  if (!str) return ''

  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map(x => x.charAt(0).toUpperCase() + x.slice(1).toLocaleLowerCase())
    .join(' ')
}

export const generateRandomString = (length: number): string => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export const capitalizeString = (str?: string): string => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

/**
 * Safely converts a value to a string, handling cases where the value might be an object.
 * This is particularly useful for email fields that might be returned as objects from APIs.
 *
 * @param value - The value to convert to a string (can be string, object with email property, or any other type)
 * @returns A string representation of the value
 *
 * @example
 * getSafeString('test@example.com') // returns 'test@example.com'
 * getSafeString({ email: 'test@example.com' }) // returns 'test@example.com'
 * getSafeString(null) // returns ''
 * getSafeString(undefined) // returns ''
 */
export const getSafeString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value
  }
  if (value && typeof value === 'object' && 'email' in value) {
    const emailValue = (value as { email: unknown }).email
    if (emailValue === null || emailValue === undefined) {
      return ''
    }
    return String(emailValue)
  }
  if (value === null || value === undefined) {
    return ''
  }
  return String(value)
}
